import { render, staticRenderFns } from "./APP1.vue?vue&type=template&id=53967142&scoped=true"
import script from "./APP1.vue?vue&type=script&lang=js"
export * from "./APP1.vue?vue&type=script&lang=js"
import style0 from "./APP1.vue?vue&type=style&index=0&id=53967142&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53967142",
  null
  
)

export default component.exports